export default __webpack_public_path__ + "static/media/portfolio-cai-3.3ba0756c.jpg";